module.exports = __webpack_public_path__ + "static/media/white-logo.aecd6afc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/white-logo.svg
// module id = 673
// module chunks = 0